





















































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import SkeletonBlock from '@/components/atoms/SkeletonBlock.vue'

@Component({
  components: {
    SkeletonBlock,
  },
})
export default class ApparelAddToCartAreaSkeleton extends Vue {}
